// extracted by mini-css-extract-plugin
export default {"card":"SubscriptionsForecast_card__dDoBu","cardTitle":"SubscriptionsForecast_cardTitle__+cqmb"};